import axios from 'axios';
const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;

const api = axios.create({
  baseURL: API_ENDPOINT,
});

// Add an interceptor to attach the token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Retrieve token from local storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const lineId = localStorage.getItem('x-line-id');
    if (lineId) {
      config.headers['x-line-id'] = lineId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
